import { OrderByDir } from "../api/generated"
import {
  BackgroundTaskContextProvider,
  ScopedBackgroundTaskRefetchQuery
} from "../bg-task/BackgroundTaskContext"

type CohortShareIslandBackgroundTaskContextProviderProps = {
  resourceId: number
  cohortId: number
  children: JSX.Element
}

// Bg task context for the Cohort Share card.
// After users are added to a cohort, refetch queries to update cohort
// with added members/stats.
const CohortShareIslandBackgroundTaskContextProvider = ({
  resourceId,
  cohortId,
  children
}: CohortShareIslandBackgroundTaskContextProviderProps) => {
  return (
    <BackgroundTaskContextProvider>
      <>
        <ScopedBackgroundTaskRefetchQuery
          backbroundTaskRefetchQueries={[
            {
              type: "backbone",
              queryName: "member:facilitators",
              variables:
                // @ts-ignore
                window.App.getStore("member").request.getFacilitatorParams()
            },
            {
              type: "backbone",
              queryName: "member:members",
              // @ts-ignore
              variables: window.App.getStore("member").request.getMemberParams()
            },
            {
              type: "backbone",
              queryName: "resource:offering",
              variables: {
                id: cohortId,
                resource_id: resourceId
              }
            },
            {
              type: "apollo",
              queryName: "CohortMembers",
              variables: {
                id: cohortId,
                orderBy: [
                  { role: OrderByDir.Desc },
                  { created: OrderByDir.Asc }
                ]
              }
            },
            {
              type: "apollo",
              queryName: "CohortMembers",
              variables: {
                id: cohortId,
                orderBy: { last_activity_time: OrderByDir.Desc }
              }
            }
          ]}
        />
        {children}
      </>
    </BackgroundTaskContextProvider>
  )
}

export default CohortShareIslandBackgroundTaskContextProvider
